module.exports = __webpack_public_path__ + "media/images/emblems/Jegenstorf-coat_of_arms-d40cd7fe69adfd6f7c7c27fa3e0fedb5.svg";